export default "__VITE_ASSET__eb4c5e95__"